import React, { useEffect } from 'react';
import { Router, Switch, Route } from 'react-router-dom';

import './App.css';
import HomeRoute from '../HomeRoute/HomeRoute';
import MiDoctaRedirect from '../MiDoctaRedirect/MiDoctaRedirect';
import ProcesarLoginCidi from '../ProcesarLoginCIdi/ProcesarLoginCidi';

import { createBrowserHistory } from 'history';

import EnviarCodigo from '../SegundoLogin/EnviarCodigo/EnviarCodigo';
import SegundoLogin from '../SegundoLogin/SegundoLogin';
import Login from '../UI/Login/Login';
import VerificarCuil from '../SegundoLogin/VerificarCuil/VerificarCuil';
import { TermsAndConditions } from '../TermsAndConditions/TermsAndConditions';
import { PermissionDenied } from '../PermissionDenied/PermissionDenied';
const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

function App() {
  useEffect(() => {
    const version = process.env.REACT_APP_VERSION;
    document.cookie = `app_version=${version}; path=/`;
  }, []);
  return (
    <Router history={history} basename="/VeDiLandingPage">
      <Switch>
        <Route exact path="/" component={HomeRoute} />
        <Route path="/ir-a-midocta" component={MiDoctaRedirect} />
        <Route path="/login-usuario" render={({ location }) => <Login {...location.state} />} />
        <Route path="/verificar-cuil" component={VerificarCuil} />
        <Route path="/segundo-login" component={SegundoLogin} />
        <Route path="/enviar-codigo" component={EnviarCodigo} />
        <Route path="/terminos-y-condiciones" component={TermsAndConditions} />
        <Route path="/sin-permisos" component={PermissionDenied} />
        <Route
          path="/procesar-login-cidi"
          component={({ location }) => <ProcesarLoginCidi location={location} />}
        />
      </Switch>
    </Router>
  );
}

export default App;
